module.exports = __webpack_public_path__ + "assets/img/garamti@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/garamti@2x.png
// module id = 131
// module chunks = 0